import {get} from "@/request/utils"
import auth from '@/request/auth'

//已mixin到全局Vue不用自己引入
export default {
  methods: {
    $apiErrorHandler(err = {}) {
      this.$hideLoading()

      let desc, code
      desc = err.desc || get(err, 'message') || get(err, 'data.res.hd.desc', '') || '抱歉，我们遇到一点问题，请您稍后再试。'
      code = get(err, 'data.res.hd.code', '')

      this.$popup({
        title: '管家提示',
        content: desc,
        confirm() {
          if (code === -401 || code === -402) {
            return auth.login({
              method: 'replace'
            });
          }
        },
        cancel() {
          if (code === -401 || code === -402) {
            this.$router.go(-1);
          }
        },
        ignore() {
          if (code === -401 || code === -402) {
            this.$router.go(-1);
          }
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/apiErrorHandler.js